<template>
  <div class="truncate whitespace-normal text-xs text-neutral-600 empty:hidden">
    <slot />
  </div>
</template>
